import FAQCard from "../../components/FAQCard/FAQCard";
import VCPartnerContactInfoSubmissionForm from "../../components/VCPartnerContactInfoSubmissionForm/VCPartnerContactInfoSubmissionForm";
import { useDocumentTitle } from "../../hooks/use-document-title";
import { usePortalDefinition } from "../../hooks/use-portal-definition";
import "./VCNOnboardingPage.scss";

const VCNOnboardingPage: React.FC = () => {
  const { investorPortal } = usePortalDefinition();

  useDocumentTitle(
    !!investorPortal
      ? `${investorPortal.name}, powered by VCDB`
      : "Welcome | VCN",
    { noSuffix: true },
  );

  if (!investorPortal) {
    return null;
  }

  return (
    <div className="vcn-onboarding">
      <div className="main">
        <div className="left">
          <div className="centered-content companion">
            <div className="onb-header">{investorPortal.name}</div>
            <div className="onb-description">
              <div>{investorPortal.description}</div>
              <a
                href={investorPortal.firm?.website}
                target="_blank"
                rel="noreferrer"
              >
                Learn more about {investorPortal.name}
              </a>
            </div>
            <div className="faq-cards">
              <FAQCard header="What is VCDB.app?">
                <div>
                  <strong>VCDB</strong> is a tool we @{" "}
                  <span className="text-highlight">{investorPortal.name}</span>{" "}
                  use to manage and maintain our investor network while also
                  providing a "Yelp for VC" service to our startups.
                </div>
              </FAQCard>
              <FAQCard header="Who has access to my contact information?">
                <div className="answer">
                  Only the startups we're investing in and supporting at{" "}
                  <span className="text-highlight">{investorPortal.name}</span>.
                  You can choose to share your information with the broader{" "}
                  <strong>VCDB</strong> community, but that's entirely up to
                  you.
                </div>
              </FAQCard>
              <FAQCard header="How will my information be used?">
                <div className="answer">
                  Our startups will be able to review firms and their partners
                  to help those in future cohorts choose the right folks and
                  firms within the venture capital community to partner with.
                </div>
              </FAQCard>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="form-wrapper">
            <VCPartnerContactInfoSubmissionForm
              investorPortal={investorPortal}
            />
          </div>
        </div>
      </div>
      <div className="footer hidden"></div>
    </div>
  );
};

export default VCNOnboardingPage;
